import React, { useEffect,  useRef, useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import FASDroupdownFilterBox from "../../../../../components/FilterBox/FASFilter/FASDropDownFilter";
import FASTable from "../../../../../components/Tables/FASTable";
import { FiMenu } from "react-icons/fi";
import { format } from "date-fns";
import {
  SaleBook,
  SaleItem,
  SaleParty,
  SalesDashboard,
  SalesItemMonthParty,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Sale/SaleSlice";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import FASFilterBox from "../../../../../components/FilterBox/FASFilter/FASFilter";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export const ItemWiseSummary = () => {
  const dispatch = useDispatch();
  const { Colourdata, mainFilterData, DataMain } = useSelector(
    (state) => state.ClientLogin,
  );

  const {
    SaleBookdata,
    SalePartydata,
    SalesDashboarddata,
    SaleItemdata,
    SalesItemMonthPartyData,
  } = useSelector((state) => state.SaleSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const YearId = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonthId, setSelectedMonthId] = useState([]);

  const [selectedSaleItem, setSelectedSaleItem] = useState("");
  const [selectedSaleItemId, setSelectedSaleItemId] = useState([]);

  const [selectedSaleBook, setSelectedSaleBook] = useState("");
  const [selectedSaleBookId, setSelectedSaleBookId] = useState([]);

  const [selectedProductionGroup, setSelectedProductionGroup] = useState("");
  const [selectedProductionGroupId, setSelectedProductionGroupId] = useState(
    [],
  );

  const [selectedSaleParty, setSelectedSaleParty] = useState("");
  const [selectedSalePartyId, setSelectedSalePartyId] = useState([]);

  const [filters, setFilters] = useState({
    month: [],
    saleBook: [],
    saleItem: [],
    productionGroup: [],
    saleParty: [],
  });

  const [search, setSearch] = useState({
    month: "",
    saleBook: "",
    saleItem: "",
    productionGroup: "",
    saleParty: "",
  });
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };
  useEffect(() => {
    dispatch(SaleBook({ Firm, Year: YearId }));
    dispatch(SaleParty({ Firm, Year: YearId }));
    dispatch(SaleItem({ Firm, Year: YearId }));
    dispatch(FilterMain({ Firm, Year: YearId }));
  }, [dispatch, Firm, YearId]);

  useEffect(() => {
    if (!startDate || !endDate) return;

    const payload = {
      Firm,
      Year: YearId,
      selectestartdate: safeFormat(startDate),
      selectenddate: safeFormat(endDate),
    };

    dispatch(SalesDashboard(payload));
    dispatch(SalesItemMonthParty(payload));
  }, [dispatch, Firm, YearId, startDate, endDate]);

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.month,
    })) || [];
  const saleItemList =
    SaleItemdata?.BookName?.map((item) => ({
      label: item?.ItemName,
      value: item?.ItemID,
    })) || [];
  const saleBookList =
    SaleBookdata?.BookName?.map((item) => ({
      label: item?.BookName,
      value: item?.BookId,
    })) || [];

  const salePartyList =
    SalePartydata?.BookName?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  const productionList =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    })) || [];

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const summaryData = {
    totalSaleAmount: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.NetAmount || 0,
    ),
    totalQuantitySold: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.Finishmeter || 0,
    ),
    averageSaleAmount: formatIndianRupee(
      SalesDashboarddata?.MonthDtl?.[0]?.AvgAmt || 0,
    ),
  };
  const toggleItem = (type, item) => {
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].includes(item.value) ? [] : [item.value],
    }));
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    // {
    //   label: "NetAmount",
    //   key: "NetAmount",
    //   align: "right",
    //   format: "true",
    // },
    {
      label: "Qunatity",
      key: "Meter",
      align: "right",
      format: "true",
    },
    {
      label: "Per Meter Price",
      key: "pcs",
      align: "right",
      format: "true",
    },
    {
      label: "Amount",
      key: "Amount",
      align: "right",
      format: "true",
    },
  ];
  const getRowsdata = () => {
    return (
      SalesItemMonthPartyData?.Dtl?.map((el, index) => ({
        // srNumber: index + 1,
        ...el,
      })) || []
    );
  };
  const applyFilter = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,
        selectePdGroupdIds: filters.productionGroup?.toString() || "",
        selecteBookdIds: filters.saleBook?.toString() || "",
        selectSalepartyIds: filters.saleParty?.toString() || "",
        selectItemIds: filters.saleItem?.toString() || "",
        selectmonthname: filters.month?.toString() || "",
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      await Promise.all([
        dispatch(SalesDashboard(payload)),
        dispatch(SalesItemMonthParty(payload)),
      ]);
    } finally {
      setIsFilterLoading(false);
    }
  };
  const applyFilter1 = async () => {
    setIsFilterLoading(true);

    try {
      const payload = {
        Firm,
        Year: YearId,
        selectePdGroupdIds: selectedProductionGroupId?.toString() || "",
        selecteBookdIds: selectedSaleBookId?.toString() || "",
        selectSalepartyIds: selectedSalePartyId?.toString() || "",
        selectItemIds: selectedSaleItemId?.toString() || "",
        selectmonthname: selectedMonth?.toString() || "",
        selectestartdate: safeFormat(startDate),
        selectenddate: safeFormat(endDate),
      };

      await dispatch(SalesDashboard(payload));
      await dispatch(SalesItemMonthParty(payload));
    } finally {
      setIsFilterLoading(false);
    }
  };
  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${
      isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
    }`,
    borderLeft: `6px solid ${
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
    }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };
  const isLoading =
    !SaleBookdata ||
    !SalePartydata ||
    !SaleItemdata ||
    !SalesItemMonthPartyData ||
    !SalesDashboarddata ||
    !mainFilterData;

  if (isLoading || isFilterLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* ✅ OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <FASFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <FASFilterBox
              title="Item Sale"
              items={saleItemList}
              search={search.saleItem}
              setSearch={(val) => handleSearch("saleItem", val)}
              selectedItems={filters.saleItem}
              toggleItem={(item) => toggleItem("saleItem", item)}
              selectAll={() => selectAll("saleItem", saleItemList)}
            />
            <FASFilterBox
              title="Sale Book"
              items={saleBookList}
              search={search.saleBook}
              setSearch={(val) => handleSearch("saleBook", val)}
              selectedItems={filters.saleBook}
              toggleItem={(item) => toggleItem("saleBook", item)}
              selectAll={() => selectAll("saleBook", saleBookList)}
            />
            <FASFilterBox
              title="Production Groups"
              items={productionList}
              search={search.productionGroup}
              setSearch={(val) => handleSearch("productionGroup", val)}
              selectedItems={filters.productionGroup}
              toggleItem={(item) => toggleItem("productionGroup", item)}
              selectAll={() => selectAll("productionGroup", productionList)}
            />
            <FASFilterBox
              title="Sale Party"
              items={salePartyList}
              search={search.saleParty}
              setSearch={(val) => handleSearch("saleParty", val)}
              selectedItems={filters.saleParty}
              toggleItem={(item) => toggleItem("saleParty", item)}
              selectAll={() => selectAll("saleParty", salePartyList)}
            />

            <Button
              onClick={() => {
                applyFilter();
                handleClose();
              }}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour3,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Row className="g-4">
        <Col xl={12} lg={12} md={12}>
          {/* CARDS */}
          <Row className="g-3">
            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.totalSaleAmount}</h4>
                <h6 style={titleStyle}>Total Sale Amount</h6>
              </div>
            </Col>

            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.totalQuantitySold}</h4>
                <h6 style={titleStyle}>Total Quantity Sold</h6>
              </div>
            </Col>

            <Col xl={4} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>{summaryData.averageSaleAmount}</h4>
                <h6 style={titleStyle}>Average Sale Amount</h6>
              </div>
            </Col>
          </Row>

          <div
            className="d-none d-lg-block"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              padding: "12px",
              borderRadius: "12px",
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
              border: `1px solid ${
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
              }`,
              boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            }}
          >
            <Row className="g-3">
              {/* Month */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Month"
                  placeholder="Select Month Name"
                  data={monthList}
                  selectedValue={selectedMonth}
                  setSelectedValue={setSelectedMonth}
                  selectedId={selectedMonthId}
                  setSelectedId={setSelectedMonthId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Item */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Item Sale"
                  placeholder="Select Item Sale"
                  data={saleItemList}
                  selectedValue={selectedSaleItem}
                  setSelectedValue={setSelectedSaleItem}
                  selectedId={selectedSaleItemId}
                  setSelectedId={setSelectedSaleItemId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Sale Book */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Books"
                  placeholder="Select Sale Books"
                  data={saleBookList}
                  selectedValue={selectedSaleBook}
                  setSelectedValue={setSelectedSaleBook}
                  selectedId={selectedSaleBookId}
                  setSelectedId={setSelectedSaleBookId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Production */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Production Groups"
                  placeholder="Select Production Group"
                  data={productionList}
                  selectedValue={selectedProductionGroup}
                  setSelectedValue={setSelectedProductionGroup}
                  selectedId={selectedProductionGroupId}
                  setSelectedId={setSelectedProductionGroupId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Party */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <FASDroupdownFilterBox
                  label="Sale Party"
                  placeholder="Select Sale Party"
                  data={salePartyList}
                  selectedValue={selectedSaleParty}
                  setSelectedValue={setSelectedSaleParty}
                  selectedId={selectedSalePartyId}
                  setSelectedId={setSelectedSalePartyId}
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}
                />
              </Col>

              {/* Apply Button */}
              <Col xl={4} lg={4} md={6} sm={12}>
                <Button
                  onClick={applyFilter1}
                  style={{
                    width: "100%",
                    height: "44px",
                    borderRadius: "12px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    border: "none",
                    fontWeight: "600",
                    marginTop: "28px",
                  }}
                  className="common-hover-btn"
                >
                  Apply Filters
                </Button>
              </Col>
            </Row>
          </div>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h5
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  ITEMWISE SALE AMOUNT
                </h5>
              </div>
              <FASTable data={getRowsdata()} columns={getColumns} />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
